import React__default, { useContext } from 'react';
import { a as LocalizationContext } from '../../LocalizationContext-b021af8f.js';
import { L as Label, a as LabelTypography } from '../../index-a611bd38.js';
import '../../stringSet-91746bf1.js';
import '../../index-353f13f3.js';
import '../../_rollupPluginBabelHelpers-8e4fae98.js';
import 'prop-types';

var FrozenNotification = function FrozenNotification() {
  var stringSet = useContext(LocalizationContext).stringSet;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-frozen-channel-notification"
  }, /*#__PURE__*/React__default.createElement(Label, {
    className: "sendbird-frozen-channel-notification__text",
    type: LabelTypography.CAPTION_2
  }, stringSet.CHANNEL_FROZEN));
};

export { FrozenNotification as default };